import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAbandonedProductPreviewPlaceholder = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			fill: "#F4F9FC",
			stroke: "#B7C3CD",
			strokeWidth: 1.067,
			d: "M61.87.533c.441 0 .84.18 1.129.468.289.289.468.688.468 1.128h0v59.742c0 .44-.18.84-.468 1.128-.289.289-.688.468-1.128.468h0H2.129c-.44 0-.84-.18-1.128-.468-.289-.289-.468-.688-.468-1.128h0V2.129c0-.44.18-.84.468-1.128.289-.289.688-.468 1.128-.468h0z"
		}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			d: "M0 0L28 0 28 28 0 28z",
			transform: "translate(18 18)"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#B7C3CD",
			fillRule: "nonzero",
			d: "M24.978 13.51l-10.5-10.5c-.42-.42-1.003-.677-1.645-.677H4.667c-1.284 0-2.334 1.05-2.334 2.334v8.166c0 .642.257 1.225.689 1.657l10.5 10.5c.42.42 1.003.677 1.645.677.641 0 1.225-.257 1.645-.689l8.166-8.166c.432-.42.689-1.004.689-1.645 0-.642-.269-1.237-.689-1.657zM6.417 8.167c-.969 0-1.75-.782-1.75-1.75 0-.969.781-1.75 1.75-1.75.968 0 1.75.781 1.75 1.75 0 .968-.782 1.75-1.75 1.75z",
			transform: "translate(18 18)"
		})] })]
	})
});
export default SvgAbandonedProductPreviewPlaceholder;
